import { useEffect } from "react"
import { useContextSelector } from "use-context-selector"

import { useRequest } from "domain/core/hooks/useRequest"
import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"

import { TApiUserGroupsRes } from "../types"

export const useInitUserGroups = (): void => {
  const update = useContextSelector(
    GlobalConfigContext,
    globalConfigSelectors.update
  )

  const { data, error }: TApiUserGroupsRes = useRequest({
    url: "/v1/sso/groups",
    sendOnStart: true,
  })

  useEffect(() => {
    if (!data) return

    update({
      userGroups: { data: data.groups, error: null },
    })
  }, [data])

  useEffect(() => {
    if (!error) return

    update({
      userGroups: { data: [], error },
    })
  }, [error])
}
